module.exports = __webpack_public_path__ + "static/check-list-f140b30997f815f20f570de7cb4220d0.png";